<template>
  <b-modal
    id="crearVehiculoModal"
    :hide-footer="true"
    size="xl"
    title="Crear Vehiculo"
    @shown="onShown"
  >
    <form v-promise-btn="{ action: 'submit' }" @submit.prevent="submit">
      <card-item>
        <template>
          <div class="d-flex justify-content-center align-items-center">
            <h4 class="card-title">Crear vehículo</h4>
          </div>
        </template>
        <div class="container">
          <div class="row">
            <div class="col-12 col-md-6 form-group form-group-sm">
              <label class="label" for="patente">Patente</label>
              <input
                id="patente"
                v-model="patente"
                :disabled="sinPatente"
                :class="`form-control form-control-sm text-center bg-white${
                  !isPatenteOk && isDirty ? ' is-invalid' : ''
                }${isPatenteOk && isDirty ? ' is-valid' : ''}`"
                style="cursor: text"
                type="text"
              />
              <small v-if="isPatenteSearchLoading"
                >Buscando patente en la base de datos...</small
              >
              <small v-if="patenteMessage">{{ patenteMessage }}</small>
            </div>
            <div
              class="col-12 col-md-6 margin-config form-group form-group-sm d-flex justify-content-start align-items-center"
            >
              <input
                id="sinPatente"
                v-model="sinPatente"
                class="form-check-inline"
                type="checkbox"
                style="zoom: 1.2"
              />
              <label class="label" for="sinPatente"> Sin Patente </label>
            </div>
            <div class="col-12 col-md-6 form-group form-group-sm">
              <label class="label" for="dominio">Alias</label>
              <input
                id="dominio"
                v-model="dominio"
                :class="`form-control form-control-sm text-center bg-white${
                  isDirty && (isPatenteOk || sinPatente)
                    ? !isDominioOk
                      ? ' is-invalid'
                      : ' is-valid'
                    : ''
                }`"
                :disabled="!isPatenteOk"
                style="cursor: text"
                type="text"
              />
            </div>
            <div class="col-12 col-md-6 form-group form-group-sm">
              <label class="label" for="marca">Marca</label>
              <input
                id="marca"
                v-model="marca"
                :class="`form-control form-control-sm text-center bg-white${
                  isDirty && (isPatenteOk || sinPatente)
                    ? !isMarcaOk
                      ? ' is-invalid'
                      : ' is-valid'
                    : ''
                }`"
                :disabled="!isPatenteOk"
                style="cursor: text"
                type="text"
              />
            </div>
            <div class="col-12 col-md-6 form-group form-group-sm">
              <label class="label" for="modelo">Modelo</label>
              <input
                id="modelo"
                v-model="modelo"
                :class="`form-control form-control-sm text-center bg-white${
                  isDirty && (isPatenteOk || sinPatente)
                    ? !isModeloOk
                      ? ' is-invalid'
                      : ' is-valid'
                    : ''
                }`"
                :disabled="!isPatenteOk"
                style="cursor: text"
                type="text"
              />
            </div>

            <div class="col-12 col-md-6 form-group form-group-sm">
              <label class="label" for="color">Color</label>
              <input
                id="color"
                v-model="color"
                :class="`form-control form-control-sm text-center bg-white${
                  isDirty && (isPatenteOk || sinPatente)
                    ? !isColorOk
                      ? ' is-invalid'
                      : ' is-valid'
                    : ''
                }`"
                :disabled="!isPatenteOk"
                style="cursor: text"
                type="text"
              />
            </div>
            <div class="col-12 form-group form-group-sm">
              <label class="label" for="notas">Notas</label>
              <textarea
                id="notas"
                v-model="notas"
                :class="`form-control form-control-sm text-center bg-white`"
                style="cursor: text"
                type="text"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="d-flex justify-content-between">
                <button
                  class="btn btn-secondary"
                  type="button"
                  @click="cancelarModal"
                >
                  Cancelar
                </button>
                <button class="btn btn-primary" type="submit">Aceptar</button>
              </div>
            </div>
          </div>
        </div>
      </card-item>
    </form>
  </b-modal>
</template>

<script>
import { get } from "lodash-es";
import axios from "axios";

export default {
  name: "CrearVehiculo",
  data: () => ({
    patente: "",
    dominio: "",
    marca: "",
    modelo: "",
    color: "",
    relay: "", //+
    notas: "",
    apagadoInmediato: "", //+

    isPatenteSearchLoading: false,
    isDirty: false,
    isPatenteOk: null,
    patenteMessage: "",
    abortController: null,
    id_vehiculo: null,
    patentesConContrato: [],
    sinPatente: false,
    fieldsTouched: false,
    formSubmitted: false,
    shouldDisableFields: false,
    usarVehiculo: false,
  }),
  computed: {
    isDominioOk() {
      return !!this.dominio;
    },
    isMarcaOk() {
      return !!this.marca;
    },
    isModeloOk() {
      return !!this.modelo;
    },
    isColorOk() {
      return !!this.color;
    },
    isFormOk() {
      return (
        this.isPatenteOk &&
        !!this.isDominioOk &&
        !!this.isMarcaOk &&
        !!this.isModeloOk &&
        !!this.isColorOk
      );
    },
    showValidation() {
      return this.fieldsTouched || this.formSubmitted;
    },
  },
  methods: {
    onShown() {
      this.patente = "";
      this.sinPatente = false;
      this.dominio = "";
      this.marca = "";
      this.modelo = "";
      this.color = "";
      this.notas = "";
      this.relay = "";
      this.apagadoInmediato = "";
      this.isDirty = false;
      this.isPatenteOk = null;
      this.patenteMessage = "";
      this.abortController = null;
      this.id_vehiculo = null;
      this.fieldsTouched = false;
      this.formSubmitted = false;
      this.shouldDisableFields = false;
      this.usarVehiculo = false;
    },
    async submit() {
      this.formSubmitted = true;

      if (!this.isFormOk) {
        return this.$msgBoxOk("Algo está mal en tu formulario", {
          title: "Ups!",
        });
      } else {
        const patenteFinal = this.sinPatente ? "" : this.patente.trim();

        const resp = await axios.post("/execute", {
          method: "CLI.CrearOActualizarVehiculo",
          parameters: [
            { name: "dominio", value: this.dominio },
            { name: "patente", value: patenteFinal },
            { name: "marca", value: this.marca },
            { name: "modelo", value: this.modelo },

            { name: "color", value: this.color },
            { name: "sensor_relay", value: this.relay },
            { name: "notas", value: this.notas },
            {
              name: "apagado_inmediato",
              value: this.apagadoInmediato,
            },
          ],
        });
        if (resp.data.ok) {
          const vehiculo = get(resp.data.result, "[0][0]", null);
          this.patente = vehiculo.patente || this.patente;
          let mjeExito;
          if (vehiculo.patente && this.sinPatente) {
            mjeExito = `Vehículo creado correctamente con patente ${vehiculo.patente}`;
          } else if (this.usarVehiculo) {
            mjeExito = `Será utilizado el vehículo con patente ${vehiculo.patente}`;
          } else {
            mjeExito = `Vehiculo patente ${patenteFinal} creado correctamente`;
          }
          await this.$msgBoxOk(mjeExito, {
            title: "Éxito",
          });
          await this.$bvModal.hide("crearVehiculoModal");
          this.$emit("input", vehiculo);
        } else {
          await this.$msgBoxOk(resp.message);
        }
      }
    },
    cancelarModal() {
      this.$bvModal.hide("crearVehiculoModal");
    },
    async searchPatente(patente) {
      if (!patente) {
        this.isPatenteSearchLoading = false;
        this.abortController = null;
        this.isPatenteOk = false;
        this.patenteMessage = "Campo obligatorio";
        this.isDirty = true;
        return;
      }

      this.isPatenteSearchLoading = true;
      this.isDirty = true;
      this.abortController = new AbortController();

      try {
        const { data } = await axios.post(
          "/execute",
          {
            method: "CLI.GetVehiculoWithContratoByPatente",
            parameters: [{ name: "patente", value: this.patente }],
          },
          {
            signal: this.abortController.signal,
          },
        );

        this.isPatenteOk = data.ok;
        this.isPatenteSearchLoading = false;

        if (data.ok) {
          if (data.result[0].length === 0) {
            this.isPatenteOk = true;
          } else {
            const patentesConContrato = get(data, "result[0][0]", []);

            if (patentesConContrato.id_contrato === null) {
              this.usarVehiculo = await this.$bvModal.msgBoxConfirm(
                `La patente ${patente} existe pero no tiene contrato activo.\n¿Desea usar este vehículo para el contrato actual?`,
                (this.isPatenteOk = false),
              );

              if (this.usarVehiculo) {
                this.dominio = patentesConContrato.dominio;
                this.marca = patentesConContrato.marca;
                this.modelo = patentesConContrato.modelo;
                this.color = patentesConContrato.color;
                this.notas = patentesConContrato.notas;
                this.isPatenteOk = true;
                this.isDirty = true;
              }
            } else {
              await this.$msgBoxOk(
                `La patente ${patente} existe y tiene contrato activo.Elija otro vehiculo`,
              );
              this.isPatenteOk = false;
            }
          }
        } else {
          this.$msgBoxOk(data.message);
          let signalAborted = get(
            this.abortController,
            "signal.aborted",
            false,
          );
          if (signalAborted) {
            this.patenteMessage = "";
          } else {
            this.patenteMessage = "Ocurrió un error";
          }
          this.isPatenteOk = false;
          this.abortController = null;
        }
      } catch (e) {
        this.isPatenteSearchLoading = false;

        if (e.name === "AbortError") {
          this.patenteMessage = "";
          return;
        }

        console.error("Error en searchPatente:", e);
        await this.$msgBoxOk(e.toString(), {
          title: "Error",
        });
        this.isPatenteOk = false;
      }
    },
    onFieldFocus() {
      this.fieldsTouched = true;
    },
  },
  watch: {
    patente(val) {
      if (!val && !this.sinPatente) {
        this.dominio = "";
        this.marca = "";
        this.modelo = "";
        this.color = "";
        this.isPatenteOk = false;
        this.isDirty = true;
        return;
      }

      if (!this.sinPatente) {
        this.abortController && this.abortController.abort();
        this.searchPatente(val);
      }
    },
    sinPatente(val) {
      if (val) {
        this.abortController && this.abortController.abort();

        this.patente = "sin patente";
        this.dominio = "";
        this.marca = "";
        this.modelo = "";
        this.color = "";
        this.notas = "";
        this.isPatenteOk = true;
        this.patenteMessage =
          "Al finalizar el formulario, se creeará una patente para identificar el vehículo";
        this.isPatenteSearchLoading = false;
        this.isDirty = true;
      } else {
        this.patente = "";
        this.isPatenteOk = false;
        this.patenteMessage = "";
        this.isPatenteSearchLoading = false;
        this.isDirty = false;
      }
    },
  },
};
</script>

<style scoped>
.form-group-sin-margen {
  margin-bottom: 0 !important;
  padding: 0 !important;
}
.form-check-inline {
  margin-right: 0.5rem !important;
}
</style>
